import { render, staticRenderFns } from "./ImageModerationConsole.vue?vue&type=template&id=5baa7051&"
import script from "./ImageModerationConsole.vue?vue&type=script&lang=js&"
export * from "./ImageModerationConsole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports